import React from 'react';
import ReactDOM from 'react-dom/client';

import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import Helmet from 'react-helmet';
import { ConfigProvider } from 'antd';

import configureAmplify from './config/amplify';
import EnvironmentDetector from './components/EnvironmentDetector';
import ErrorsBoundary from './components/ErrorsBoundary';
import Root from './components/Root';
import HotjarWrapper from './components/HotjarWrapper';
import { AppStore, AllStores } from './stores';
import { BASE_THEME_CONFIG } from '@/theme';
import { BRANDING, BRANDING_PROFILE, NEUTRAL_LOGO_URL } from '@/config/branding';
import './index.scss';
import 'antd/dist/reset.css';

// Unbranded mode (SPX-6494): index.html ships the SpecterX title/favicon, so
// neutralize them at startup before any page renders.
if (BRANDING === 'unbranded') {
    document.title = BRANDING_PROFILE.productName;
    const favicon = document.querySelector<HTMLLinkElement>('link[rel="shortcut icon"]');
    if (favicon) {
        favicon.type = 'image/png';
        favicon.href = NEUTRAL_LOGO_URL;
    }
}

const initStores = (): AllStores => {
    const appStore = new AppStore();
    return appStore.stores;
};

configureAmplify(false);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <EnvironmentDetector>
        <BrowserRouter>
            <>
                <Helmet>
                    <meta
                        name="description"
                        content="Manage and control the entire organizational data from a single place,
                            no matter where it’s stored."
                    />
                </Helmet>
                <Provider {...initStores()}>
                    <ErrorsBoundary>
                        <HotjarWrapper>
                            <ConfigProvider theme={BASE_THEME_CONFIG}>
                                <Root />
                            </ConfigProvider>
                        </HotjarWrapper>
                    </ErrorsBoundary>
                </Provider>
            </>
        </BrowserRouter>
    </EnvironmentDetector>,
);
